<span class="truncate px-2 py-1 text-sm font-medium tracking-tight text-gray-800">{{ title() }}</span>
